<template>
  <!-- 下拉库存选择 -->
  <div class="InventoryBox">
    <div v-if="!data.answered">
      <!-- 问题部分 -->
      <div class="SelectBox_title">
        <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
        <!-- <span class="span" v-if="data.rule">（字数不得超过{{data.rule.length}}字）</span> -->
      </div>
      <!-- 选项部分 -->
      <div class="box">
        <div class="box_select">
          <el-select v-model="value" :placeholder="$t('flowCertificate25')">
            <el-option
              v-for="item in data.itemList"
              :key="item.itemNo"
              :disabled="(data.rule.optionCount[item.itemNo] - (item.answerCount || 0)) <= 0"
              :label="labelTxt(item.itemDes)"
              :value="item.itemId">
              <div v-for="o in JSON.parse(item.itemDes)" :key="JSON.stringify(o)">
                <span>{{o.txt}}</span>
              </div>
            </el-option>
          </el-select>
        </div>
        <span>{{optionCount}}</span>
      </div>
    </div>
    <!-- 有答案后 -->
    <div v-else>
      <!-- 问题部分 -->
      <div class="SelectBox_title">
        <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
        <!-- <span class="span" v-if="data.rule">（字数不得超过{{data.rule.length}}字）</span> -->
      </div>
      <!-- 选项部分 -->
      <div class="box">
        <div class="box_select">
          <el-select v-model="value" :disabled="disabledBol" :placeholder="$t('flowCertificate25')">
            <el-option
              v-for="item in data.itemList"
              :key="item.itemNo"
              :disabled="(data.rule.optionCount[item.itemNo] - (item.answerCount || 0)) <= 0"
              :label="labelTxt(item.itemDes)"
              :value="item.itemId">
              <div v-for="o in JSON.parse(item.itemDes)" :key="JSON.stringify(o)">
                <span>{{o.txt}}</span>
              </div>
            </el-option>
          </el-select>
        </div>
        <span>{{optionCount}}</span>
      </div>
    </div>
    <!-- 答案隐藏文字id -->
    <div class="answerObj none">{{answerObj}}</div>
    <div class="isNecessary none">{{data.rule ? (data.rule.isNecessary ? 1 : 0) : 0}}</div>
  </div>
</template>

<script>
export default {
  name: 'InventoryBox',
  props: {
    data: Object,
    disabledBol: Boolean     // 是否disabled
  },
  computed: {
    // 答案
    answerObj () {
      let obj
      if (!this.value) {
        obj = {
          msg: '请选择后提交'
        }
      } else {
        obj = {
          questionId: this.data.questionId,
          item: this.value
        }
      }
      return obj
    },
    // 库存
    optionCount () {
      console.log(this.$i18n.locale, 'this.$i18n.locale')
      if (this.value) {
        let list = this.data.itemList || []
        for (let i in list) {
          if (list[i].itemId === this.value) {
            let optionCount = this.data.rule.optionCount
            // 被选人次
            let num = list[i].answerCount || 0
            if (this.$i18n.locale === 'en') {
              return `${(optionCount[list[i].itemNo] - num) < 0 ? 0 : (optionCount[list[i].itemNo] - num)}Spot(s) Left`
            } else  {
              return `剩余${(optionCount[list[i].itemNo] - num) < 0 ? 0 : (optionCount[list[i].itemNo] - num)}个名额`
            }
          }
        }
      } else {
        return ''
      }
    }
  },
  data () {
    return {
      value: ''
    }
  },
  methods: {
    // 处理选项文字
    labelTxt (val) {
      let arr = JSON.parse(val)
      return arr[0].txt
    },
    // 初始化
    init () {
      if (this.data.answered) {
        this.value = this.data.answered
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.InventoryBox{
  .SelectBox_title{
    margin-top: 24px;
    font-size: 16px;
    line-height: 22px;
  }
  .box{
    margin-top: 8px;
    display: flex;
    // .box_select{
    //   width: 352px;
    // }
    span{
      margin-left: 16px;
      color: #999;
      line-height: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/topic/public/inventory-box.vue